import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '@services/authentication/authentication.service';


@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {

  constructor(private authenticationService: AuthenticationService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    var roles = route.data.roles as Array<string>;

    if (this.authenticationService.isAccessTokenValid()) {
      if (this.authenticationService.userHasAnyRole(roles)) {
        return true;
      }

      this.router.navigate(['/auth/login'], { queryParams: { returnUrl: "/", message: "Sie haben keinen Zugriff auf die von Ihnen aufgerufene Seite. Bitte melden Sie sich mit dem entsprechendem Konto an." } });
      return false;
    }

    this.router.navigate(['/auth/login'], { queryParams: { returnUrl: state.url, message: "" } });
    return false;
  }
}
